import React from 'react';
import { createGlobalStyle } from 'styled-components';

const DriversGridGlobalStyles = createGlobalStyle`
  .drag-over-active > th,
  .drag-over-active > td {
    background-color: #b3c2c9ff !important;
  }

  [data-element="updating-driver-row"] {
    opacity: 0.5;
    transition: opacity 0.2s ease-in-out;
    pointer-events: none;
  }
`;

export const DriversGridStyles = () => <DriversGridGlobalStyles />;
